export default "__VITE_ASSET__DFglcLmv__"